// muiSectionHeaderStyles.tsx
import { styled } from '@mui/material/styles';

export interface SectionHeaderContainerProps {
  /** Text color for the inner <h3> */
  color?: string;
  /** Border color for the container (only sets borderColor like original) */
  borderColor?: string;
}

export const SectionHeaderContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'borderColor',
})<SectionHeaderContainerProps>(({ color, borderColor }) => ({
  position: 'relative',
  zIndex: 2,
  marginTop: 10,
  width: '100%',

  fontFamily: `'SharpSansDisplayNo1-Medium', tahoma, helvetica, arial, sans-serif`,
  fontSize: 16,
  textTransform: 'capitalize',
  color: '#131313',

  // Note: original only set border-color, not any border style/width
  ...(borderColor ? { borderColor } : {}),

  '& h3': {
    fontSize: 30,
    marginTop: 20,
    letterSpacing: '1px',
    backgroundColor: '#fff',
    padding: '0 10px 0 0',
    marginBottom: 10,
    fontFamily: `'PizzaHutFont', helvetica, arial, sans-serif`,
    float: 'left',
    ...(color ? { color } : {}),
  },
}));
